import OverViewContent from './Content';

const OverViewTab = () => {
    return <OverViewContent />;
};

export default OverViewTab;
